import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { payRequestIdZodSchema } from "./pay-request-id";
import { payRequestRecipientZodSchema } from "./pay-request-recipient";
import { payRequestRequesterZodSchema } from "./pay-request-requester";

const payRequestResendCommandZodObject = z.object({
    _id: idZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("PAY_REQUEST_RESEND_COMMAND"),
    payRequestId: payRequestIdZodSchema,
    /**
     * Contact info for payers of the pay request
     * a notification will (have) be(en) sent to these contacts
     */
    recipients: z.array(payRequestRecipientZodSchema).min(1),
    requester: payRequestRequesterZodSchema,
});

type PayRequestResendCommand = z.infer<typeof payRequestResendCommandZodObject>;
const payRequestResendCommandZodSchema: z.ZodSchema<PayRequestResendCommand> =
    payRequestResendCommandZodObject;

type FactoryParams = Except<
    PayRequestResendCommand,
    "_id" | "_type" | "_createdAt"
>;
const payRequestResendCommandFactory = (params: FactoryParams) => {
    const command: PayRequestResendCommand = {
        ...params,
        _id: generateId({ prefix: "resend_pay_request_command__" }),
        _type: "PAY_REQUEST_RESEND_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    payRequestResendCommandFactory,
    payRequestResendCommandZodObject,
    payRequestResendCommandZodSchema,
};
export type {
    PayRequestResendCommand,
    FactoryParams as ResendPayRequestCommandFactoryParams,
};
